import React from 'react'

import { useExchange, useExchanges } from 'contexts/Exchanges'

// In general trying to replicate exchange brand colours here, but if there are
// collisions (e.g. Binance/Bybit) then it's whatever the traders ask for
const EXCHANGE_COLORS: Record<string, React.CSSProperties> = {
  binance: { backgroundColor: '#F0B90B' },
  okex: { backgroundColor: '#000', color: '#FFF' },
  bybit: { backgroundColor: '#ba2511', color: '#FFF' },
  intx: { backgroundColor: '#004cec', color: '#FFF' },
  hyperliquid: { backgroundColor: '#a5c9c0' },
}

type ExchangeProps = {
  id: number
  colorful?: boolean
}

const Exchange: React.FC<ExchangeProps> = ({ id, colorful = false }) => {
  const exchange = useExchange(id)

  if (exchange.loading) {
    return <span>Loading...</span>
  } else if (!exchange.data) {
    return <>[Unknown Exchange]</>
  }
  return (
    <span
      style={
        colorful && EXCHANGE_COLORS[exchange.data.name]
          ? {
              padding: '0 2px',
              color: '#000',
              ...EXCHANGE_COLORS[exchange.data.name],
            }
          : undefined
      }
    >
      {exchange.data.name}
    </span>
  )
}

export default Exchange

export const ExchangeOptions: React.FC = () => {
  const exchanges = useExchanges()
  const exchangeOptions = exchanges.loading
    ? []
    : exchanges.data
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(exchange => (
          <option key={exchange.id} value={exchange.id}>
            {exchange.name}
          </option>
        ))

  return <>{exchangeOptions}</>
}
